module.exports = __webpack_public_path__ + "static/media/portada.fd7af6f0.jpg";